<form
  [formGroup]="sendForm"
  class="send-communication-form flex h-full min-h-0 min-w-0 flex-col"
  (ngSubmit)="sendCommunication()"
>
  <div class="compose-sheet flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-slate-200 bg-white">
    <div class="compose-row group">
      <span class="compose-label">Plantilla</span>
      <div class="compose-field min-w-0 flex-1">
        <p-select
          inputId="sendCommunicationTemplate"
          formControlName="templateId"
          [options]="templates"
          optionLabel="label"
          optionValue="value"
          [loading]="templatesLoading"
          [filter]="true"
          filterPlaceholder="Buscar plantilla"
          placeholder="Selecciona una plantilla"
          appendTo="body"
          styleClass="compose-select w-full"
          (onChange)="onTemplateChange()"
        />
        @if (sendForm.controls.templateId.touched && sendForm.controls.templateId.invalid) {
          <small class="compose-error">Selecciona una plantilla</small>
        }
      </div>
    </div>

    <div class="compose-row">
      <span class="compose-label">Para</span>
      <div class="compose-field min-w-0 flex-1">
        <input
          pInputText
          id="sendCommunicationToEmail"
          formControlName="toEmail"
          class="compose-input w-full"
          placeholder="correo@ejemplo.com"
          autocomplete="email"
        />
        @if (sendForm.controls.toEmail.touched && sendForm.controls.toEmail.invalid) {
          <small class="compose-error">Ingresa un correo válido</small>
        }
      </div>
    </div>

    <div class="compose-row send-communication-cc">
      <span class="compose-label">CC</span>
      <div class="compose-field min-w-0 flex-1">
        <p-autocomplete
          inputId="sendCommunicationCcEmail"
          formControlName="ccEmails"
          styleClass="compose-autocomplete w-full"
          inputStyleClass="compose-input"
          [multiple]="true"
          [typeahead]="false"
          [unique]="true"
          separator=","
          [addOnBlur]="true"
          fluid
          placeholder="Agregar copia (Enter o coma)"
          (onAdd)="onCcAdd($event)"
        />
      </div>
    </div>

    <div class="compose-row">
      <span class="compose-label">Asunto</span>
      <div class="compose-field min-w-0 flex-1">
        <input
          pInputText
          id="sendCommunicationSubject"
          formControlName="subject"
          class="compose-input w-full"
          placeholder="Asunto del correo"
        />
        @if (sendForm.controls.subject.touched && sendForm.controls.subject.invalid) {
          <small class="compose-error">Ingresa un asunto</small>
        }
      </div>
    </div>

    <div class="send-communication-message-editor min-h-0 flex-1 flex flex-col">
      @if (previewLoading) {
        <div class="flex flex-1 items-center justify-center gap-2 text-sm text-slate-400">
          <i class="pi pi-spin pi-spinner"></i>
          Generando vista previa…
        </div>
      } @else if (sendForm.controls.templateId.value) {
        <p-editor
          formControlName="messageBody"
          styleClass="compose-editor"
          [style]="messageEditorStyle"
        >
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Negrita"></button>
              <button type="button" class="ql-italic" aria-label="Cursiva"></button>
              <button type="button" class="ql-underline" aria-label="Subrayado"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-list" [attr.value]="'ordered'" aria-label="Lista numerada"></button>
              <button type="button" class="ql-list" [attr.value]="'bullet'" aria-label="Lista con viñetas"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-align" aria-label="Alineación"></select>
            </span>
          </ng-template>
        </p-editor>
        @if (sendForm.controls.messageBody.touched && sendForm.controls.messageBody.invalid) {
          <small class="compose-error px-3 pb-2">Ingresa el contenido del mensaje</small>
        }
      } @else {
        <div class="flex flex-1 items-center justify-center px-4 text-sm text-slate-400">
          Selecciona una plantilla para editar el mensaje
        </div>
      }
    </div>

    <div class="compose-row compose-attachments items-start">
      <span class="compose-label pt-1">Adjuntos</span>
      <div class="compose-field min-w-0 flex-1">
        @if (attachmentsLoading) {
          <span class="inline-flex items-center gap-1.5 py-1 text-xs text-slate-400">
            <i class="pi pi-spin pi-spinner"></i>
            Cargando adjuntos…
          </span>
        } @else {
          <div class="flex flex-wrap items-center gap-1.5 py-0.5">
            @for (file of composeAttachments; track file.key) {
              <span
                class="compose-attachment-chip"
                [class.compose-attachment-chip--extra]="!file.fromTemplate"
                [pTooltip]="attachmentTooltip(file)"
                tooltipPosition="top"
              >
                <i class="pi pi-paperclip text-[11px]"></i>
                <span class="truncate max-w-[10rem]">{{ file.name }}</span>
                <button
                  type="button"
                  class="compose-attachment-remove"
                  aria-label="Quitar adjunto"
                  (click)="removeComposeAttachment(file.key)"
                >
                  <i class="pi pi-times text-[10px]"></i>
                </button>
              </span>
            }
            <input #extraAttachmentInput type="file" class="hidden" multiple (change)="onExtraAttachmentSelect($event)" />
            <button
              type="button"
              class="compose-attachment-add"
              (click)="extraAttachmentInput.click()"
            >
              <i class="pi pi-plus text-[10px]"></i>
              Agregar
            </button>
          </div>
          @if (composeAttachments.length === 0) {
            <small class="text-[11px] text-slate-400">Solo se muestran nombres; los nuevos se envían con el correo y no se almacenan.</small>
          }
        }
      </div>
    </div>
  </div>

  @if (showFooterActions()) {
    <div class="mt-3 flex shrink-0 flex-col items-end gap-2 sm:flex-row sm:items-center sm:justify-between">
      <p class="text-xs text-slate-500 sm:mr-auto">
        Si tienes una firma por defecto en tu perfil, se anexará al enviar.
      </p>
      <p-button
        type="submit"
        label="Enviar"
        icon="pi pi-send"
        [loading]="sending"
        [disabled]="sending || sendForm.invalid || attachmentsLoading"
        appDisableUnless="COMMUNICATION_WRITE"
      />
    </div>
  }
</form>
